import {populateWallpapersState, provideWallpaperState} from "@/states/wallpaper-state";
import {populateUserState, provideUserState} from "@/states/user-state";
import { provideFeatureFlags } from './feature-flags-state';
import { populatePromotionState, providePromotionPrices } from './promotion-state';

export function registerStateProviders() {
    provideWallpaperState();
    provideUserState();
    provideFeatureFlags();
    providePromotionPrices();
}

export async function populateStates() {
    const wallpapersState = populateWallpapersState();
    const userState = populateUserState();
    const populatePrices = populatePromotionState();
    await Promise.all([wallpapersState, userState, populatePrices]);
}
